
<div class="multiselect" :class="[classStyle]" v-click-outside="handleFocusOut">
  <div class="select-block" @click="onClick()">
    <a href="javascript:;" class="selected-text " :tabindex="isDisable ? -1 : 0">
      <span v-html="textLimit" class="textLimit">
      </span>
    </a>
    <div :class="{'erroSpan' : error}"  v-if="isShowErrorTxt"> {{error}}</div>
  </div>
  <ul class="select-list-block" v-if="state.isOpen" tabinde="1"  :style="'width:'+listWidth+'px'">
    <template v-if="hasAll">
      <li class="option" :value="'all'"  @mousedown="selectAll()" 
      :tabindex="0" @keypress.enter="selectAll" >
        <!-- <Checkbox v-model:isCheck="state.all" class="text" :padding="'15px 24px'":text="'All'" :hoverEffect="true":value="'all'" :key="'itemAll'" size="sm"></Checkbox> -->
        <span class="checkmark-block" :class="{'check': state.all}">
          <span class="checkmark">
            <div class="checkitem checkmark_stem"></div>
            <div class="checkitem checkmark_kick"></div>
          </span>
        </span>
        <a href="javascript:;" class="text padding" 
          v-html="hasAll"
          :tabindex="-1">
        </a>
      </li>
    </template>
    <template v-for="(item,i) in options">
      <li class="option" :value="item.val" id="item.val" @mousedown="onChange(item)" 
      :tabindex="0" @keypress.enter="onChange(item)" >
      <!-- @focus=" i == options.length-1 ? handleFocusOut() : ()=>{}" -->
        <!-- <Checkbox v-model:isCheck="state.dataCheck[i]" class="text" :padding="'15px 24px'" :text="item.text" :hoverEffect="true" :value="i.toString()" :key="'item'+i" size="sm"></Checkbox> -->
        <span class="checkmark-block" :class="{'check': checkStyle(item)}">
          <span class="checkmark">
            <div class="checkitem checkmark_stem"></div>
            <div class="checkitem checkmark_kick"></div>
          </span>
        </span>
        <a href="javascript:;" class="text padding"
          v-html="item.isI18n ?  t(item.isI18n):item.text"
          :tabindex="-1">
        </a>
      </li>
    </template>
  </ul>
</div>

